import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export function scrollAddClass() {
  document.querySelectorAll(".js-scroll").forEach((el, index) => {
    ScrollTrigger.create({
      trigger: el,
      id: index + 1,
      start: 'top center+=200px',
      toggleClass: { targets: el, className: "is-active" },
      once: true,
      // markers: true,
    });
  });

  // ScrollTrigger.refresh();
}
